import * as amplitude from "@amplitude/analytics-react-native"
import ChapterProgressCongrats from "@common/chapters/ChapterProgressCongrats"
import { IconImageM } from "@common/components/icons/IconsM"
import TextM from "@common/components/text/TextM"
import championsConstants from "@data/constants/championsConstants"
import { apiIdle, apiRequest } from "@data/redux/actions/api"
import {
    pullNextCongrats,
    pullNextScreenParams,
    putCongrats,
    putNextScreenParams,
} from "@data/redux/actions/navigation"
import * as WebBrowser from "expo-web-browser"
import LottieView from "lottie-react-native"
import React, { useContext, useEffect, useRef, useState } from "react"
import {
    BackHandler,
    Platform,
    ScrollView,
    TouchableOpacity,
    View,
} from "react-native"
import { StatusBar } from "@common/systemBars/StatusBar"
import { useSafeAreaInsets } from "react-native-safe-area-context"
import { connect } from "react-redux"
import facebook from "../../../assets/social/facebook.png"
import instagram from "../../../assets/social/instagram.png"
import linkedin from "../../../assets/social/linkedin.png"
import QuizzConfirmedCongrats from "../../quiz/QuizzConfirmedCongrats"
import QuizzInitializedCongrats from "../../quiz/QuizzInitializedCongrats"
import ProfileCompletedCongrats from "../../student/account/profile/ProfileCompletedCongrats"
import ActivityFinalizedCongrats from "../../student/activity/execute/ActivityFinalizedCongrats"
import ActivityReviewedCongrats from "../../student/activity/read/ActivityReviewedCongrats"
import NewTodoCongrats from "../../student/activity/todo/NewTodoCongrats"
import ChampionBubble from "../../student/champions/ChampionBubble"
import { samVariantForActivity } from "../../student/champions/ChampionImageM"
import LeagueCongrats from "../../student/league/LeagueCongrats"
import ChallengeLaunchCongrats from "../../student/organize/challenges/ChallengeLaunchCongrats"
import ChallengeProgressCongrats from "../../student/organize/challenges/ChallengeProgressCongrats"
import MyProgressCongrats from "../../student/progress/my progress/MyProgressCongrats"
import NewTitleCongrats from "../../student/progress/my progress/NewTitleCongrats"
import PetalsGainedCongrats from "../../student/progress/my progress/PetalsGainedCongrats"
import NewAchievementCongrats from "../../student/progress/successes/NewAchievementCongrats"
import ShopProductPurchasedCongrats from "../../student/shop/ShopProductPurchasedCongrats"
import ShareStatsCongrats from "../../student/social/ShareStatsCongrats"
import DownloadAppCongrats from "../../student/tutoring/DownloadAppCongrats"
import OfferChosenCongrats from "../../student/tutoring/OfferChosenCongrats"
import ApplicationStepCongrats from "../../tutor/application/ApplicationStepCongrats"
import ApplicationFinishedCongrats from "../../tutor/application/motivation/ApplicationFinishedCongrats"
import FilledButtonM from "../components/button/FilledButtonM"
import useAutoModeMaybeOpen from "../hooks/useAutoModeMaybeOpen"
import useNextTodoActivity from "../hooks/useNextTodoActivity"
import { theme } from "../theme/theme"
import { DimensionsContext } from "../utils/mobileUtils"
import GenericCongrats from "./GenericCongrats"

export const congratsTypes = {
    CHALLENGE_LAUNCHED: "challenge_launched",
    SHOP_PRODUCT_PURCHASED: "SHOP_PRODUCT_PURCHASED",
    ACTIVITY_REVIEWED: "ACTIVITY_REVIEWED",
    ACTIVITY_REJECTED_LOSSES: "ACTIVITY_REJECTED_LOSSES",
    ACTIVITY_FINALIZED: "activity_finalized",
    NEW_ACHIEVEMENT: "new_achievement",
    CHALLENGE_PROGRESS: "challenge_progress",
    PROFILE_COMPLETED: "PROFILE_COMPLETED",
    OFFER_CHOSEN: "OFFER_CHOSEN",
    SCORING: "scoring",
    GENERIC: "GENERIC",
    LEAGUE_PROGRESS: "LEAGUE_PROGRESS",
    MY_PROGRESS: "MY_PROGRESS",
    NEW_TITLE_CONGRATS: "NEW_TITLE_CONGRATS",
    PETALS_GAINED: "PETALS_GAINED",
    SHARE_STATS: "SHARE_STATS",
    NEW_TODO_CONGRATS: "NEW_TODO_CONGRATS",
    QUIZZ_INITIALIZED: "QUIZZ_INITIALIZED",
    QUIZZ_CONFIRMED: "QUIZZ_CONFIRMED",
    APPLICATION_STEP_CONGRATS: "PERSONAL_INFO_CONGRATS",
    APPLICATION_FINISHED_CONGRATS: "APPLICATION_FINISHED_CONGRATS",
    DOWNLOAD_APP: "DOWNLOAD_APP",
    CHAPTER_PROGRESS_CONGRATS: "CHAPTER_PROGRESS_CONGRATS",
}

export const CongratsScreen = (props) => {
    // ** Component props
    const { navigation, route } = props
    const nextScreen = route.params?.nextScreen ?? null
    const insets = useSafeAreaInsets()
    const [show, setShow] = useState(false)

    const nextScreenParams = props.nextScreenParams
    const congrats = props.congrats
    const { todoActivities, autoSelectNext } = props.nextScreenParams
    const { selectNextActivity, isLoading } = useNextTodoActivity()
    const tryOpenAutoMode = useAutoModeMaybeOpen()

    const supportLinks = [
        {
            icon: instagram,
            label: "Instagram",
            url: "https://www.instagram.com/masteur_com/",
        },
        {
            icon: linkedin,
            label: "Linkedin",
            url: "https://www.linkedin.com/company/masteur/",
        },
        {
            icon: facebook,
            label: "Facebook",
            url: "https://www.facebook.com/Masteur.fr",
        },
    ]

    // ** Handle click on hardware back button
    useEffect(() => {
        if (!congrats?.[0]?.congratsType) {
            props.pullNextScreenParams()
            props.pullNextCongrats()
            navigation.goBack()
        } else {
            amplitude.track("congrats." + congrats?.[0]?.congratsType)
        }

        setTimeout(() => {
            setShow(true)
        }, 1000)

        setTimeout(() => {
            setShow(false)
        }, 5000)

        const subscription = BackHandler.addEventListener(
            "hardwareBackPress",
            backPressed
        )
        return () => {
            subscription.remove()
        }
    }, [])
    const backPressed = () => true

    const animation = useRef(null)

    function renderContinueButton() {
        return (
            <FilledButtonM
                color={theme.colors.primary}
                onPress={
                    !champion()
                        ? onPress
                        : () => {
                              championsBubbleRef.current?.onChampionBubbleNext()
                          }
                }
                style={{
                    width:
                        dimensions?.width < 800
                            ? dimensions?.width - 20
                            : dimensions?.width / 1.2,
                    alignSelf: "center",
                    marginTop: 5,
                }}
                loading={isLoading}
                label="CONTINUER"
            />
        )
    }

    const proceedWithNavigation = () => {
        // In a group session, if the student just finished an activity with an
        // empty todo queue, take over here (after the congrats screen played)
        // instead of running the default "go to next activity" path.
        if (congrats[0]?.congratsType === congratsTypes.ACTIVITY_FINALIZED) {
            const finishedActivity = congrats[0]?.congratsData?.activity
            if (tryOpenAutoMode(finishedActivity)) {
                props.pullNextScreenParams()
                props.pullNextCongrats()
                if (navigation.canGoBack()) navigation.goBack()
                return
            }
        }
        if (nextScreen) {
            const paramsCopy = { ...nextScreenParams }
            navigation.replace(nextScreen, paramsCopy)
        } else if (autoSelectNext) {
            const lastActivityId = congrats[0]?.congratsData?.activity?.id
            const selected = selectNextActivity(todoActivities, lastActivityId)

            if (selected) {
                return
            }
            navigation.goBack()
        } else if (navigation.canGoBack()) {
            navigation.goBack()
            props.pullNextScreenParams()
        } else {
            // To be able to use a generic congrats in auth screens
            if (props.token) navigation.replace("menu")
            else navigation.replace("login")

            props.pullNextScreenParams()
        }
        props.pullNextCongrats()
    }

    const onPress = () => {
        // Remove first element
        let congratsCopy = congrats?.slice()
        congratsCopy.shift()

        // Navigate to next element or go back
        if (congratsCopy.length > 0) {
            props.pullNextCongrats()

            navigation.replace("congrats", {
                nextScreen,
            })
        } else {
            proceedWithNavigation()
        }
    }

    const renderCongratsContent = (congratsType, congratsData) => {
        switch (congratsType) {
            case congratsTypes.CHALLENGE_LAUNCHED:
                return (
                    <ChallengeLaunchCongrats
                        challenge={congratsData?.new_challenge}
                        activities={congratsData?.new_activities}
                    />
                )
            case congratsTypes.ACTIVITY_FINALIZED:
                return (
                    <ActivityFinalizedCongrats
                        congratsData={congratsData}
                        activity={congratsData?.activity}
                        onContinuePress={
                            !champion()
                                ? onPress
                                : () => {
                                      championsBubbleRef.current?.onChampionBubbleNext()
                                  }
                        }
                        renderContinueButton={renderContinueButton}
                        navigation={navigation}
                    />
                )

            case congratsTypes.NEW_ACHIEVEMENT:
                return <NewAchievementCongrats achievement={congratsData} />

            case congratsTypes.CHALLENGE_PROGRESS:
                return (
                    <ChallengeProgressCongrats
                        challenge={congratsData?.challenge}
                        activity={congratsData?.activity}
                    />
                )
            case congratsTypes.SHOP_PRODUCT_PURCHASED:
                return (
                    <ShopProductPurchasedCongrats
                        shopProduct={congratsData?.shopProduct}
                    />
                )
            case congratsTypes.ACTIVITY_REVIEWED:
                return (
                    <ActivityReviewedCongrats
                        activity={congratsData?.activity}
                    />
                )

            case congratsTypes.PROFILE_COMPLETED:
                return <ProfileCompletedCongrats />

            case congratsTypes.OFFER_CHOSEN:
                return <OfferChosenCongrats onPress={onPress} />

            case congratsTypes.GENERIC:
                return (
                    <GenericCongrats
                        congratsText={congratsData?.text}
                        congratsTitle={congratsData?.title}
                        component={congratsData?.component}
                    />
                )
            case congratsTypes.LEAGUE_PROGRESS:
                return (
                    <LeagueCongrats
                        congratsText={congratsData?.text}
                        congratsTitle={congratsData?.title}
                        rankings={congratsData?.rankings}
                    />
                )
            case congratsTypes.MY_PROGRESS:
                return (
                    <MyProgressCongrats
                        userSkillSets={congratsData?.userSkillSets}
                    />
                )
            case congratsTypes.NEW_TITLE_CONGRATS:
                return (
                    <NewTitleCongrats
                        userSkillSet={congratsData?.userSkillSet}
                    />
                )

            case congratsTypes.PETALS_GAINED:
                return (
                    <PetalsGainedCongrats
                        petalsGainedCount={congratsData?.petalsGainedCount}
                    />
                )
            case congratsTypes.SHARE_STATS:
                return (
                    <ShareStatsCongrats
                        shopProduct={congratsData?.shopProduct}
                    />
                )
            case congratsTypes.NEW_TODO_CONGRATS:
                return (
                    <NewTodoCongrats
                        todo={congratsData?.todo}
                        studentId={congratsData?.studentId}
                    />
                )

            case congratsTypes.QUIZZ_INITIALIZED:
                return (
                    <QuizzInitializedCongrats
                        congratsTitle={congratsData?.title}
                        score={congratsData?.score}
                        congratsText={congratsData?.text}
                    />
                )

            case congratsTypes.QUIZZ_CONFIRMED:
                return (
                    <QuizzConfirmedCongrats
                        congratsTitle={congratsData?.title}
                        congratsText={congratsData?.text}
                    />
                )

            case congratsTypes.APPLICATION_STEP_CONGRATS:
                return (
                    <ApplicationStepCongrats
                        congratsTitle={congratsData?.title}
                        congratsText={congratsData?.text}
                    />
                )
            case congratsTypes.APPLICATION_FINISHED_CONGRATS:
                return (
                    <ApplicationFinishedCongrats
                        congratsTitle={congratsData?.title}
                        congratsText={congratsData?.text}
                    />
                )
            case congratsTypes.CHAPTER_PROGRESS_CONGRATS:
                return (
                    <ChapterProgressCongrats
                        congratsTitle={congratsData?.title}
                        congratsText={congratsData?.text}
                        activity={congratsData?.activity}
                    />
                )
            case congratsTypes.DOWNLOAD_APP:
                return <DownloadAppCongrats />

            default:
                return <></>
        }
    }

    const championsBubbleRef = useRef()

    const champion = () => {
        if (congrats.length === 0) return null

        const activity = congrats[0]?.congratsData?.activity

        switch (congrats[0]?.congratsType) {
            case congratsTypes.QUIZZ_INITIALIZED:
                const index =
                    congrats[0]?.congratsData?.score >= 80
                        ? 0
                        : congrats[0]?.congratsData?.score >= 50
                        ? 1
                        : 2
                return {
                    name: "sam",
                    variant: [
                        championsConstants.sam_quizz_initialized_congrats
                            .variant[index],
                    ],
                    texts: [
                        championsConstants.sam_quizz_initialized_congrats.texts[
                            index
                        ],
                    ],
                }
            case congratsTypes.QUIZZ_CONFIRMED:
                return {
                    name: "tina",
                    variant:
                        championsConstants.tina_quizz_confirmed_congrats
                            .variant,
                    texts: championsConstants.tina_quizz_confirmed_congrats
                        .texts,
                }
            case congratsTypes.CHALLENGE_LAUNCHED:
                if (
                    props.user?.challenges?.length === 1 &&
                    props.user?.xp === 0
                )
                    return {
                        name: "zoe",
                        variant:
                            championsConstants
                                .zoe_challenge_launch_congrats_first.variant,
                        texts: championsConstants
                            .zoe_challenge_launch_congrats_first.texts,
                    }
                else
                    return {
                        name: "zoe",
                        variant:
                            championsConstants.zoe_challenge_launch_congrats_any
                                .variant,
                        texts: championsConstants
                            .zoe_challenge_launch_congrats_any.texts,
                    }
            case congratsTypes.CHAPTER_PROGRESS_CONGRATS:
                const chapterActivity = congrats[0]?.congratsData?.activity
                if (
                    chapterActivity?.student_chapter?.xp_gained !==
                    chapterActivity?.student_chapter?.xp_total
                ) {
                    return {
                        name: "zoe",
                        variant:
                            championsConstants.zoe_chapter_progress_congrats
                                .variant,
                        texts: championsConstants.zoe_chapter_progress_congrats
                            .texts,
                    }
                } else if (
                    chapterActivity?.student_chapter?.xp_gained <
                    props.xpToValidateChapter
                ) {
                    return {
                        name: "zoe",
                        variant:
                            championsConstants
                                .zoe_chapter_progress_congrats_todo_ended
                                .variant,
                        texts: championsConstants
                            .zoe_chapter_progress_congrats_todo_ended.texts,
                    }
                } else {
                    return {
                        name: "zoe",
                        variant:
                            championsConstants
                                .zoe_chapter_progress_congrats_finalized
                                .variant,
                        texts: championsConstants
                            .zoe_chapter_progress_congrats_finalized.texts,
                    }
                }
            case congratsTypes.ACTIVITY_REVIEWED:
                return {
                    name: "sam",
                    variant: samVariantForActivity(activity),
                    texts: [activity?.review_comment],
                }
            case congratsTypes.SHOP_PRODUCT_PURCHASED:
                const shopProduct = congrats[0]?.congratsData?.shopProduct
                return {
                    name: "tina",
                    variant: "main",
                    texts: [shopProduct?.congrats_message],
                }

            case congratsTypes.APPLICATION_STEP_CONGRATS:
                const champion = congrats[0]?.congratsData?.champion
                const championText = congrats[0]?.congratsData?.text
                return {
                    name: champion,
                    variant: "happy",
                    texts: [championText],
                }

            case congratsTypes.NEW_ACHIEVEMENT:
            case congratsTypes.PROFILE_COMPLETED:
            case congratsTypes.OFFER_CHOSEN:
            case congratsTypes.GENERIC:
            default:
                return null
        }
    }

    function renderCongratsChampion() {
        return !champion() ? (
            <></>
        ) : (
            <ChampionBubble
                name={champion().name}
                variant={champion().variant}
                championPosition="left"
                texts={champion().texts}
                onNextPress={onPress}
                ref={championsBubbleRef}
                style={{ marginTop: 30 }}
            />
        )
    }

    const dimensions = useContext(DimensionsContext)

    if (congrats[0]?.congratsType === congratsTypes.ACTIVITY_FINALIZED) {
        return (
            <View
                style={{
                    flex: 1,
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "space-between",
                }}
            >
                {renderCongratsContent(
                    congrats[0]?.congratsType,
                    congrats[0]?.congratsData
                )}
            </View>
        )
    }

    return (
        <View
            style={{
                flex: 1,
                backgroundColor: "#fff",
                width: dimensions?.width,
                paddingTop: insets.top,
                alignSelf: "center",
            }}
        >
            {show &&
                (congrats[0]?.congratsType === congratsTypes.NEW_ACHIEVEMENT ||
                    congrats[0]?.congratsType ===
                        congratsTypes.NEW_TITLE_CONGRATS ||
                    congrats[0]?.congratsType ===
                        congratsTypes.QUIZZ_CONFIRMED) && (
                    <LottieView
                        autoPlay
                        speed={1}
                        loop={false}
                        pointerEvents="none"
                        ref={animation}
                        style={{
                            width:
                                Platform.OS !== "web"
                                    ? dimensions?.width * 1.4
                                    : dimensions?.width,
                            alignSelf: "center",
                            position: "absolute",
                            top: 0,
                        }}
                        // Find more Lottie files at https://lottiefiles.com/featured
                        source={require("../../../assets/animations/62717-confetti.json")}
                    />
                )}
            <ScrollView>
                {congrats.length > 0 && (
                    <>
                        {renderCongratsContent(
                            congrats[0]?.congratsType,
                            congrats[0]?.congratsData
                        )}
                        {renderCongratsChampion(congrats[0]?.congratsType)}
                        {congrats[0]?.congratsType ===
                            congratsTypes.QUIZZ_CONFIRMED && (
                            <View
                                style={{
                                    marginTop: 20,
                                    alignItems: "center",
                                    alignSelf: "center",
                                    flexDirection: "row",
                                }}
                            >
                                {supportLinks?.map((link, index) => {
                                    return (
                                        <TouchableOpacity
                                            key={index}
                                            style={{
                                                width:
                                                    dimensions?.width /
                                                        supportLinks?.length -
                                                    10,
                                                marginHorizontal: 5,
                                            }}
                                            onPress={() => {
                                                WebBrowser.openBrowserAsync(
                                                    link?.url
                                                ).then()
                                            }}
                                        >
                                            <View
                                                style={{
                                                    alignItems: "center",
                                                }}
                                            >
                                                <IconImageM
                                                    source={link?.icon}
                                                    width={60}
                                                    style={{
                                                        marginBottom: 6,
                                                    }}
                                                />
                                                <TextM
                                                    style={{
                                                        fontsize: 30,
                                                        textAlign: "center",
                                                    }}
                                                    fontWeight="Bold"
                                                    wrap
                                                >
                                                    {link?.label}
                                                </TextM>
                                            </View>
                                        </TouchableOpacity>
                                    )
                                })}
                            </View>
                        )}
                    </>
                )}

                <View style={{ height: 100 }} />
            </ScrollView>

            {!congrats[0]?.hideButton && (
                <View
                    style={{
                        backgroundColor: theme.colors.whiteTransparentMore,
                        paddingVertical: 10,
                        width: dimensions?.width,
                        position: "absolute",
                        alignSelf: "center",
                        bottom: 0,
                    }}
                >
                    {renderContinueButton()}
                </View>
            )}
            <StatusBar
                style="dark"
                backgroundColor={theme.colors.white}
                translucent={false}
            />
        </View>
    )
}

const mapStateToProps = (state) => {
    return {
        postChallengeRequest: state.api.postChallengeAsStudent?.request,
        postChallengeSuccess: state.api.postChallengeAsStudent?.success,
        postChallengeError: state.api.postChallengeAsStudent?.error,
        postChallengeSuccessData: state.api.postChallengeAsStudent?.data,
        token: state.data.session?.object?.token,
        user: state.data.currentUser?.object,
        isLive: state.liveMode.isLiveModeEnabled,
        liveSessionId: state.liveMode?.liveSessionId,
        schoolSubjects: state.data.schoolSubjects,
        xpToValidateChapter: state.data.staticData?.xp_to_validate_chapter,
        congrats: state.navigation?.congrats,
        nextScreenParams: state.navigation?.nextScreenParams,
    }
}

const mapDispatchToProps = {
    apiRequest,
    apiIdle,
    pullNextScreenParams,
    putNextScreenParams,
    pullNextCongrats,
    putCongrats,
}

export default connect(mapStateToProps, mapDispatchToProps)(CongratsScreen)
